var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._g(_vm._b({class:_setup.badge(_setup.props),attrs:{"data-component":"CsBadge"}},'span',_setup.attrs,false),_setup.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }